import { Component, inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { AuthStore } from 'src/app/calvin-emr-shared/state/auth/auth.store';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [NavBarComponent, ToastModule],
  providers: [MessageService],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'calvin-emr';
  private mediaQueryList?: MediaQueryList;
  private themeChangeListener?: (e: MediaQueryListEvent) => void;

  private authStore = inject(AuthStore);
  private router = inject(Router);
  private platformId = inject(PLATFORM_ID);

  constructor() {
    const auth = getAuth();

    onAuthStateChanged(auth, (user) => {
      if (user !== null) {
        this.authStore.rehydrate(user.uid);
      } else {
        this.authStore.setRehydrateFailed();
      }
    });
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      // Check system preference for dark mode
      this.mediaQueryList = window.matchMedia('(prefers-color-scheme: dark)');

      // Set initial theme
      this.updateTheme(this.mediaQueryList.matches);

      // Listen for changes in system preference
      this.themeChangeListener = (e: MediaQueryListEvent) => this.updateTheme(e.matches);
      this.mediaQueryList.addEventListener('change', this.themeChangeListener);
    }
  }

  ngOnDestroy(): void {
    if (this.mediaQueryList && this.themeChangeListener) {
      this.mediaQueryList.removeEventListener('change', this.themeChangeListener);
    }
  }

  private updateTheme(isDark: boolean): void {
    const htmlElement = document.documentElement;
    if (isDark) {
      htmlElement.classList.add('p-dark');
      htmlElement.classList.remove('p-light');
    } else {
      htmlElement.classList.add('p-light');
      htmlElement.classList.remove('p-dark');
    }
  }
}
